module.exports = __webpack_public_path__ + "media/images/favicon/favicon-57-8190e6c1423b44904157408ff6b081ba.png";